import { render, staticRenderFns } from "./ActionPhone.vue?vue&type=template&id=bf3d2868&"
import script from "./ActionPhone.vue?vue&type=script&lang=js&"
export * from "./ActionPhone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports